import { ReactElement } from 'react'
import { InsertChart } from '@mui/icons-material'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import { observer } from 'mobx-react-lite'
import { Button } from '../../../../../src/ui-components/forms/Button'

const ShowDiagramsButton = observer((): ReactElement => {
  const uiStore = useUiStateStore()
  const icon = <InsertChart />
  return (
    <Button
      icon={icon}
      text="diagrams"
      onClick={() => uiStore.setShowPartsCatalogDiagramDrawer(true)}
      variant="transparent"
    />
  )
})

export default ShowDiagramsButton
